import { Link } from "react-router-dom";

function CheckItem({ text, included = true }: { text: string; included?: boolean }) {
  return (
    <div className="flex items-start gap-4 mb-4">
      <div className={`w-10 h-10 flex items-center justify-center rounded-full shrink-0 ${included ? "bg-emerald-100 text-emerald-600" : "bg-red-100 text-red-500"}`}>
        <i className={included ? "ri-check-line text-lg" : "ri-close-line text-lg"}></i>
      </div>
      <div className="pt-2">
        <h4 className="text-sm font-bold text-gray-900">{text}</h4>
      </div>
    </div>
  );
}

export default function PoolOpeningsClosings() {
  return (
    <div>
      {/* Hero */}
      <section className="relative bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 py-20 md:py-28">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8">
          <h1 className="text-3xl md:text-5xl font-bold text-white">Pool Openings &amp; Closings</h1>
        </div>
      </section>

      {/* Pool Openings */}
      <section className="py-12 md:py-16 bg-white">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16">
            {/* Left - Text */}
            <div>
              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
                <strong>Pool Openings</strong>
              </h2>
              <div className="w-16 h-1 bg-emerald-600 mb-6"></div>

              <p className="text-sm md:text-base text-gray-700 leading-relaxed mb-6">
                ATLAS PRO SERVICES LLC is here to make your pool opening stress-free and seamless. Before your service, make sure to follow a few simple steps and let our expert team handle the rest.
              </p>

              <h3 className="text-lg font-bold text-gray-900 mb-4">
                <strong>How to Prepare For Your Service:</strong>
              </h3>

              <ol className="list-decimal list-inside text-sm md:text-base text-gray-700 leading-relaxed space-y-2 mb-8">
                <li>Make sure the power is turned on at the pump location.</li>
                <li>Remove water and debris from the cover.</li>
                <li>Make sure your water level is at the proper operating level.</li>
                <li>Make sure we have access to all of your pool equipment to get pool up and running.</li>
                <li>Dogs must be kept inside.</li>
              </ol>
            </div>

            {/* Right - Image */}
            <div>
              <img
                              src="/images/Openingandclosings.jpg"
                alt="Backyard In-Ground Swimming Pool on sunny day"
                className="w-full h-auto rounded-lg border border-gray-200"
                width={1257}
                height={835}
              />
            </div>
          </div>

          {/* Included / Not Included */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 mt-12">
            <div>
              <h3 className="text-lg font-bold text-gray-900 mb-6">
                <strong>Included Services</strong>
              </h3>
              <CheckItem text="Remove Cover & Store" />
              <CheckItem text="Remove Winter Plugs" />
              <CheckItem text="Install Any Ladders, Rails, or Diving Boards" />
              <CheckItem text="Add Shock & Algaecide to Your Pool" />
              <CheckItem text="Start Up Pump & Filter System" />
            </div>
            <div>
              <h3 className="text-lg font-bold text-gray-900 mb-6">
                <strong>Not Included</strong>
              </h3>
              <CheckItem text="Adjust Water Level" included={false} />
              <CheckItem text="Cleaning Cover" included={false} />
              <CheckItem text="Cleaning Filter" included={false} />
              <CheckItem text="Balance Water" included={false} />
              <CheckItem text="Vacuum Pool" included={false} />
              <div className="flex items-start gap-4 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full shrink-0 bg-red-100 text-red-500">
                  <i className="ri-close-line text-lg"></i>
                </div>
                <div className="pt-2">
                  <h4 className="text-sm font-bold text-gray-900">Any Major Repairs</h4>
                  <p className="text-xs text-gray-500 mt-1">*We will recommend scheduling a service appointment.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Pool Closings */}
      <section className="py-12 md:py-16 bg-gray-50">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8">
          <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
            <strong>Pool Closings</strong>
          </h2>
          <div className="w-16 h-1 bg-emerald-600 mb-6"></div>

          <p className="text-sm md:text-base text-gray-700 leading-relaxed mb-6">
            ATLAS PRO SERVICES LLC is here to make closing your pool stress-free. Follow a few simple steps and let our experts handle the rest.
          </p>

          <h3 className="text-lg font-bold text-gray-900 mb-4">
            <strong>How to Prepare For Your Service:</strong>
          </h3>

          <ol className="list-decimal list-inside text-sm md:text-base text-gray-700 leading-relaxed space-y-2 mb-10 max-w-4xl">
            <li>Lower the water level just below the skimmer.</li>
            <li>Have the cover and plugs out and ready for us to use. If your cover or plugs are located in a shed or garage, please make sure that the pathway is clear and can easily be accessed by our team.</li>
            <li>Please ensure the power is on at the equipment.</li>
            <li>We ask that you have the pool deck clear of all toys, floats, furniture, umbrellas, and etc.</li>
            <li>Dogs must be kept inside.</li>
          </ol>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16">
            <div>
              <h3 className="text-lg font-bold text-gray-900 mb-6">
                <strong>Included Services</strong>
              </h3>
              <CheckItem text="Blow Out & Plug the Inground Pool Lines" />
              <CheckItem text="Plug Skimmer and Return ( Above Ground Pools)" />
              <CheckItem text="Remove Ladders, Rails, or Diving Boards" />
              <CheckItem text="Rinse off DE & Cartridge Filters" />
              <CheckItem text="Add Winter Chemicals" />
              <CheckItem text="Cover Pool" />
              <CheckItem text="Store Equipment in Shed or Garage." />
            </div>
            <div>
              <h3 className="text-lg font-bold text-gray-900 mb-6">
                <strong>Not Included</strong>
              </h3>
              <CheckItem text="We will NOT take out stairs (Above Ground Pools)" included={false} />
              <CheckItem text="Put away Toys, Floats, Furniture, etc" included={false} />
              <div className="flex items-start gap-4 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full shrink-0 bg-red-100 text-red-500">
                  <i className="ri-close-line text-lg"></i>
                </div>
                <div className="pt-2">
                  <h4 className="text-sm font-bold text-gray-900">Any Major Repairs</h4>
                  <p className="text-xs text-gray-500 mt-1">*We will report what we find and make a service appointment.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-14 md:py-20 bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8 text-center">
          <Link
            to="/contact"
            className="inline-block bg-emerald-600 hover:bg-emerald-700 text-white font-semibold px-8 py-4 rounded-md text-sm md:text-base transition-colors whitespace-nowrap"
          >
            Contact Us To Schedule A Service
          </Link>
        </div>
      </section>
    </div>
  );
}